import { createRequestTypes } from '../utils';

export const INGREDIENT_LIST = createRequestTypes('ingredient/INGREDIENT_LIST');
export const INGREDIENT = createRequestTypes('ingredient/INGREDIENT');
export const SAVE_INGREDIENT = createRequestTypes('ingredient/SAVE_INGREDIENT');

export const NEW_INGREDIENT = 'ingredient/NEW_INGREDIENT';

